export default "__VITE_ASSET__By9SnPDB__"